export default __webpack_public_path__ + "static/media/services_municipal_3.09068eb5.jpg";